import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [successMsg, setSuccessMsg] = useState("");

    // Handle form input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Form validation
    const validateForm = () => {
        let tempErrors = {};
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.email) tempErrors.email = "Email is required";
        else if (!/\S+@\S+\.\S+/.test(formData.email)) tempErrors.email = "Invalid email format";
        if (!formData.phone) tempErrors.phone = "Phone number is required";
        if (!formData.message) tempErrors.message = "Message is required";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        emailjs
            .send(
                "service_zfttaib",
                "template_rnjlp3q",
                formData,
                "8r4CN3Mtxg_iajAud"
            )
            .then(() => {
                setSuccessMsg("Your message has been sent successfully!");
                setFormData({ name: "", email: "", phone: "", message: "" });
                setErrors({});
                setTimeout(() => setSuccessMsg(""), 5000);
            })
            .catch(() => {
                alert("Failed to send message. Please try again.");
            });
    };

    return (
        <div className="container mx-auto px-6 py-12">
            <h1 className="text-3xl font-bold text-center mb-6" data-aos="fade-up">
                CONTACT US
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-12" data-aos="fade-up">
                Our contact page is your gateway to staying connected with our school community. Whether you’re a student, parent, educator, or community member, we welcome your questions, feedback, and suggestions.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-aos="fade-up">
                {/* Contact Form */}
                <div className="bg-gray-200 shadow-lg rounded-2xl p-6" data-aos="fade-up">
                    <h2 className="text-xl font-bold mb-4">Get in Touch</h2>
                    {successMsg && <p className="text-green-600 mb-4">{successMsg}</p>}
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full mb-2 p-3 border rounded-md"
                        />
                        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                        
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full mb-2 p-3 border rounded-md"
                        />
                        {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}

                        <input
                            type="tel"
                            name="phone"
                            placeholder="Phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="w-full mb-2 p-3 border rounded-md"
                        />
                        {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}

                        <textarea
                            name="message"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                            className="w-full mb-2 p-3 border rounded-md h-32"
                        />
                        {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}

                        <button
                            type="submit"
                            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                            Send Message
                        </button>
                    </form>
                </div>

                {/* Contact Info Cards */}
                <div className="space-y-8 md:space-y-20" data-aos="fade-up">
                    <div className="bg-gray-200 shadow-lg rounded-2xl p-6 flex items-center">
                        <img
                            src="https://img.freepik.com/free-vector/open-email-envelope_1020-530.jpg"
                            alt="Email"
                            className="w-12 h-12 mr-4"
                        />
                        <div>
                            <h3 className="text-lg font-bold">Email Us</h3>
                            <p>contact@school.com</p>
                        </div>
                    </div>
                    <div className="bg-gray-200 shadow-lg rounded-2xl p-6 flex items-center">
                        <img
                            src="https://img.freepik.com/free-vector/phone_53876-25489.jpg"
                            alt="Phone"
                            className="w-12 h-12 mr-4"
                        />
                        <div>
                            <h3 className="text-lg font-bold">Call Us</h3>
                            <p>+123 456 7890</p>
                        </div>
                    </div>
                    <div className="bg-gray-200 shadow-lg rounded-2xl p-6 flex items-center">
                        <img
                            src="https://img.freepik.com/premium-vector/address-location-vector-design-illustration_1281743-7234.jpg"
                            alt="Address"
                            className="w-12 h-12 mr-4"
                        />
                        <div>
                            <h3 className="text-lg font-bold">Visit Us</h3>
                            <p>123 School Street, City, Country</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Google Map */}
          <div className="w-full mt-12" data-aos="fade-up">
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.944362561638!2d77.4176361737714!3d12.975410414797382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3a338baf95c3%3A0x8bf52f23026c1552!2sSVN%20Convent%20and%20English%20High%20School!5e0!3m2!1sen!2sin!4v1739194939980!5m2!1sen!2sin" 
                    width="100%" 
                    height="350" 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg shadow-lg"
                ></iframe>
            </div>
        </div>
    );
};

export default Contact;
